import React from 'react';

import { ECGCaptureItem, PopUp } from 'components';
import { PatientTableItem } from 'types/types';
import { useState } from 'hooks';
import styles from './styles.module.sass';
import { getLocaleDate } from 'utils';
import { Box } from '@mui/material';

export const PatientECGPlotCell: React.FC<PatientTableItem> = ({ waveform }) => {
  const [isPopUpOpen, setIsPopUpOpen] = useState(false);
  if (typeof waveform === 'string') {
    return <div>{waveform}</div>;
  }

  const lastWaveform = waveform.at(-1);

  const onPopUpToggle = () => {
    setIsPopUpOpen((prev) => !prev);
  };

  if (!lastWaveform) {
    return <div>N\A</div>;
  }

  return (
    <>
      {isPopUpOpen && (
        <PopUp isOpen={isPopUpOpen} onPopUpToggle={onPopUpToggle}>
          <Box className={styles.container}>
            {waveform.map((waveform) => (
              <div className={styles.waveform_item} key={waveform.id}>
                <h2 className={styles.heading}>{getLocaleDate(waveform.submittedTimestamp, 'dddd, D MMMM YYYY')}</h2>
                <ECGCaptureItem {...waveform} titleClass={styles.lead_title} assessmentClass={styles.assessment} />
              </div>
            ))}
          </Box>
        </PopUp>
      )}
      <div onClick={onPopUpToggle} className={styles.plot}>
        <ECGCaptureItem {...lastWaveform} />
      </div>
    </>
  );
};
